import { ROLE_TYPE_CAREGIVER } from "../../../constants/RegisterConstants";

export const canAccessCaregiverRole = (authStore: any) => {
  const currentRoleType = String(authStore?.getUserRoleType?.() || "").trim().toLowerCase();
  if (currentRoleType === ROLE_TYPE_CAREGIVER || authStore?.isAdmin?.()) {
    return true;
  }

  const availableRoleTypes = Array.from(new Set(
    [
      String(authStore?.currentUserContext?.user?.legacyRoleType || "").trim().toLowerCase(),
      ...(Array.isArray(authStore?.currentUserContext?.profile?.selectedRoleTypes)
        ? authStore.currentUserContext.profile.selectedRoleTypes
        : []
      ),
      ...(Array.isArray(authStore?.availableRoles) ? authStore.availableRoles : []),
    ]
      .map((roleType: any) => String(roleType || "").trim().toLowerCase())
      .filter(Boolean),
  ));

  return availableRoleTypes.includes(ROLE_TYPE_CAREGIVER);
};
